import { connect } from 'react-redux';
import { cleanOrders } from '../../../../redux/actions/Orders';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
});

const mapDispatchToProps = dispatch => ({
  cleanOrders() {
    dispatch(cleanOrders());
  },
});

export default SuccessOrderPageBody => connect(mapStateToProps, mapDispatchToProps)(SuccessOrderPageBody);
